import React from "react"
import { graphql } from "gatsby"

import Layout from "../../components/Layout"
import Seo from "../../components/Seo"
import Card from "../../components/blog/card/card"
import BlogNav from "../../components/blog/nav/nav"

import "./tabs.scss"

export const data = graphql`
  query($slug: String!) {
    dibCategories(slug: { eq: $slug }) {
      title
      slug
    }
    allDibPosts(
      filter: { categories: { elemMatch: { slug: { eq: $slug } } } }
    ) {
      edges {
        node {
          title
          summary
          slug
          publishedAt
          readtime
          featuredImage
          categories {
            title
            slug
          }
          author {
            name
            slug
            photo
          }
        }
      }
    }
  }
`

const TabsPage = props => {

  const posts = props.data.allDibPosts.edges
  const category = props.data.dibCategories

  return (
    <Layout>
      <Seo title="Blog" />
      <div className="container mt-4">
        <div className="blog-header">
          <h1>{category.title}</h1>
          <BlogNav />
        </div>
        <div className="row">
          {posts.map((post, index) => (
            <div key={index} className="col-sm-6 col-md-4 mb-2">
              <Card post={post.node} tab={category} />
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default TabsPage
